
import { defineComponent, onMounted, ref } from 'vue'
import { useI18n } from "vue-i18n/index";
import { useRoute } from 'vue-router';

import eventService from '@/core/services/EventService';
import { errManager } from "@/core/config/Tools";

//components
import AddEdit from "./AddEdit.vue"

export default defineComponent({
    name: "medals-gral-manager",
    components: {
        AddEdit
    },
    setup() {
        const loading = ref(false)
        const route = useRoute()
        const { id } = route.params
        const { t } = useI18n();
        const modalMedalRef = ref<any>(null)
        const listMedals = ref<any>([])

        const openModal = () => {
            if (modalMedalRef.value) {
                modalMedalRef.value.openModal();
            }
        }

        const getListMedals = async () =>{
            loading.value = true
            await eventService.getMedals(id)
            .then((res)=>{
                listMedals.value = res.data
                loading.value = false
            }).catch(({response})=>{
                loading.value = false
                errManager(response)
            })
        }

        onMounted(()=>{
            getListMedals()
        })

        return {
            t,
            id,
            modalMedalRef,
            loading,
            listMedals,
            //events
            openModal,
            getListMedals
        }


    },
})
